/**
 * Nivam paid-social landing page — conversion tracking.
 *
 * Fires an AddToCart signal (Meta Pixel + GA4) when a visitor clicks a
 * "Shop the Collection" CTA, since the CTA is a cart permalink and the
 * visitor leaves the page before any cart JS runs.
 *
 * Both fbq and gtag are optional — nothing here throws if the pixel or GA4
 * tag is not installed on the store.
 */
(function () {
  var root = document.querySelector('[data-nvm-landing]');
  if (!root) return;

  var currency = root.dataset.currency || 'INR';

  // Each CTA may target its own product, so read the clicked button first and only
  // fall back to the section-level default when a button carries no product of its own.
  function productFor(cta) {
    return {
      id: cta.dataset.ctaProductId || root.dataset.productId || null,
      title: cta.dataset.ctaProductTitle || root.dataset.productTitle || 'Nivam set of three',
      value: parseFloat(cta.dataset.ctaProductPrice || root.dataset.productPrice || '0') || 0
    };
  }

  function track(cta, placement) {
    var product = productFor(cta);

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: product.title,
        content_type: 'product',
        content_ids: product.id ? [product.id] : [],
        value: product.value,
        currency: currency
      });
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        currency: currency,
        value: product.value,
        cta_placement: placement,
        items: product.id
          ? [{ item_id: product.id, item_name: product.title, price: product.value, quantity: 1 }]
          : []
      });
    }
  }

  root.querySelectorAll('[data-nvm-cta]').forEach(function (cta) {
    cta.addEventListener('click', function () {
      track(cta, cta.dataset.nvmCta);
    });
  });
})();
